var generateStyle = function generateStyle() {
  return {
    title: {
      margin: '2rem 0',
      wordWrap: 'break-word',
      overflowWrap: 'break-word'
    },
    description: {
      margin: '2rem 0'
    }
  };
};
export default generateStyle;